document.addEventListener('DOMContentLoaded', function () {
  const grid    = document.querySelector('#product-grid');
  const nextBox = document.querySelector('.meet_infinite_next');
  const trigger = document.querySelector('#infinite-trigger');
  const loader  = document.querySelector('#loader');

  if (!grid || !trigger) return;

  const getNext = () => {
    const a = nextBox && nextBox.querySelector('a[href]');
    return a ? a.getAttribute('href') : null;
  };

  let nextUrl = getNext();
  let loading = false;
  let done    = !nextUrl;

  const recheckBanners = () => {
    if (typeof window.checkAndInsertBanners === 'function') {
      try { window.checkAndInsertBanners(); } catch(e) {}
    }
  };

  async function fetchNext() {
    if (loading || done || !nextUrl) return;
    loading = true;
    if (loader) loader.style.display = 'block';

    try {
      const res  = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const newGrid  = doc.querySelector('#product-grid');
      const newItems = newGrid ? Array.from(newGrid.children) : [];

      if (newItems.length) {
        newItems.forEach(n => grid.appendChild(n));

        const newNextBox = doc.querySelector('.meet_infinite_next');
        if (newNextBox) {
          if (nextBox) nextBox.innerHTML = newNextBox.innerHTML;
          nextUrl = getNext();
          done    = !nextUrl;
        } else {
          nextUrl = null;
          done    = true;
        }

        document.dispatchEvent(new Event('shopify:section:loaded'));
        document.dispatchEvent(new Event('contentUpdated'));
        recheckBanners();
      } else {
        done = true;
      }
    } catch (e) {
      console.error('Infinite scroll error:', e);
      done = true;
    } finally {
      if (loader) loader.style.display = 'none';
      loading = false;
      if (done && observer) observer.disconnect();
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if (entry.isIntersecting) fetchNext(); });
  }, { rootMargin: '1000px 0px' });

  if (!done) observer.observe(trigger);
});
